<template>
  <div>
    <h2>Relatórios</h2>
    <report />
  </div>
</template>

<script>
import Report from '@/components/Report'
export default {
  components: {
    "report": Report
  }
}
</script>

<style>

</style>
